import { render, staticRenderFns } from "./IndicesDetail.vue?vue&type=template&id=2754e1c5&"
import script from "./IndicesDetail.vue?vue&type=script&lang=js&"
export * from "./IndicesDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports